import { useTranslation } from "react-i18next";

interface IRPSCharacter {
  alt?: string,
  image?: string,
  hp: number,
  hpLeft: number,
}

const RPSCharacter = ({ alt, image, hp, hpLeft }:IRPSCharacter) => {
  const { t } = useTranslation();

  return (
    <div className={`relative flex flex-col bg-graySecondary p-2 rounded-xl shadow-goldSecondary`}>
      <img
        className={"h-[120px] w-[90px] object-cover rounded-xl object-center"}
        alt={t(`${alt ?? 'icon_of_character'}`)}
        src={image}
      />
      <div
        className={
          "mt-2 w-full h-4 relative bg-[#800020] rounded-full overflow-hidden align-self-end flex items-center justify-center shadow-green"
        }
      >
        <span className="z-10">
          {hpLeft}/{hp}
        </span>
        <div
          className={`h-full bg-[#228B22] absolute left-0`}
          style={{ width: `${(hpLeft / hp) * 100}%` }}
        ></div>
      </div>
    </div>
  );
};

export default RPSCharacter;
